import { render, staticRenderFns } from "./BudgetKke.vue?vue&type=template&id=5af39065&"
import script from "./BudgetKke.vue?vue&type=script&lang=js&"
export * from "./BudgetKke.vue?vue&type=script&lang=js&"
import style0 from "./BudgetKke.vue?vue&type=style&index=0&id=5af39065&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports